import React from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import Page from "components/Page";
import { apiPost2 } from "../../api";
import { httpClient } from "../../api/httpClient";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Button,
  CardGroup,
  CardHeader
} from 'reactstrap';
import { tokenIframe } from "../../redux/actions/aContenidos";
import { stringABase64 } from "../../utils/Encriptar"
import { ambienteAplicacion, holaMundo, urlListarRenovaciones } from "../../constants/urls";

// import { IconWidget } from 'components/Widget';
// import {

//   MdRateReview,
//   MdThumbUp,
// } from 'react-icons/lib/md';
// import { R_OK } from "constants";

class Principal extends React.Component {



  constructor(props) {
    super(props)
    this.state = {
      token: "",
      numeroRenovaciones: 0
    }
  }

  onCompras = () => {
    this.props.history.replace({
      pathname: this.props.datosUsuario.dataUsuario.usu_tipo_usuario === 'cliente' ? `/mis-compras` : `/listado-compras`
    });
  }

  onRenovaciones = () => {

    this.props.history.replace({
      pathname: `/listado-renovaciones`
    });
  }

  async obtenerRenovacion() {



    //return {transaccion: true}
    try {


      const url = `${urlListarRenovaciones}${this.props.datosUsuario.dataUsuario.brokerCodigo}&cliCodigoCore=${this.props.datosUsuario.dataUsuario.cliCodigoCore}&ambiente=${ambienteAplicacion}&ramo=VEH%C3%8DCULOS`;
      const response = await httpClient.post(url, {
        "rangoFecha": null,
        "filtrosAtributos": {}
      });

      if (response.errorDescripcion) {
        throw new Error('Error al obtener la siniestralidad. Intente nuevamente más tarde.');
      }

      return response;
    } catch (error) {
      console.error('Error en validarSiniestralidad:', error);
      return {
        transaccion: false,
        mensaje: 'Ocurrió un problema con el servicio. Por favor, contacte a soporte técnico.'
      };
    }
  }

  onCotizaciones = () => {

    this.props.history.replace({
      pathname: `/listado-cotizaciones`
    });
  }


  async componentDidMount() {
    await tokenIframe();

    try {
      const respHolaMundo = await apiPost2(holaMundo, {});
      console.log("Respuesta Hola Mundo:", respHolaMundo);
    } catch (err) {
      console.error("Error Hola Mundo:", err);
    }

    const dataUsuario = this.props.datosUsuario && this.props.datosUsuario.dataUsuario;
    const usuTipoUsuario = dataUsuario && dataUsuario.usu_tipo_usuario;
    if (usuTipoUsuario === "broker-user" || usuTipoUsuario === "asesor-user" || usuTipoUsuario === "canal-user") {
      var renovaciones = await this.obtenerRenovacion()

       if  (renovaciones && renovaciones.arrayrenovaciones)  {
          this.setState({
            numeroRenovaciones: renovaciones.arrayrenovaciones ? renovaciones.arrayrenovaciones.length : 0
          })
      }
     }
  }

  render() {


    //Renovaciones COndiciones
    let bloquearRenovaciones = true;


    if (
      (this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "canal-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "asesor-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "admin-user") &&
      this.props.datosUsuario.dataUsuario.userIsLoggedIn === true
    ) {
      bloquearRenovaciones = false;
    }

    let bloquearOpciones = false;

    console.log('this.props.datosUsuario.dataUsuario.usu_tipo_usuario', this.props.datosUsuario.dataUsuario.usu_tipo_usuario)

    if (this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "cliente" || this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "aglutinador-user") {
      bloquearRenovaciones = true
      bloquearOpciones = true;
    }
 
    let verCompromisos = false;
    if (
      (this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "canal-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "broker-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "asesor-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "admin-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "soporte-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "distribucion-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "aglutinador-user" ||

        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "lineas-personales-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "hogar-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "pymes-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "accidentes-personales-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "responsabilidad-civil-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "lineas-financieras-user" ||
        this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "vehiculos-user"
      ) &&
      this.props.datosUsuario.dataUsuario.userIsLoggedIn === true
    ) {
      verCompromisos = true;
    }


    return (
      <Page title="Inicio" breadcrumbs={[{ name: "inicio", active: true }]}>
        <Row>
          <Col lg={6} md={12} sm={12} xs={12}>
            <Col lg={12} md={12} sm={12} xs={12}>
              <Card className={"cr-widget bg-light card background-white"} >
                <Row style={{ width: "50%", textAlign: "center" }}>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <div style={{ textAlign: "center" }}><i className="fa fa-file-pdf-o fa-3x" aria-hidden="true" style={{ color: "#001871" }}></i></div>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <span className="mr-1 badge badge-info badge-pill" style={{ fontSize: "1.5em", background: "#001871", marginTop: "0.3em" }}>
                      {this.props.datosDashboard.datosDashboard.contadorPolizas && this.props.datosDashboard.datosDashboard.contadorPolizas !== undefined ? this.props.datosDashboard.datosDashboard.contadorPolizas : 0}
                    </span>
                  </Col>
                </Row>
                <Row style={{ width: "50%", textAlign: "center" }}>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <CardTitle>CONSULTA</CardTitle>
                    {this.props.datosUsuario.dataUsuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario !== 'cliente' &&
                      <CardTitle>TUS VENTAS</CardTitle>
                    }
                    {this.props.datosUsuario.dataUsuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario === 'cliente' &&
                      <CardTitle>TUS COMPRAS</CardTitle>
                    }
                  </Col>
                  
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <Button className={"btn btn-primary"} onClick={this.props.datosUsuario.dataUsuario.usu_tipo_usuario !== 'aglutinador-user' ? this.onCompras : undefined} style={{ display: "block", margin: "auto" }} >
                      <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                      {this.props.datosUsuario.dataUsuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario !== 'cliente' && "Ver Ventas"}
                      {this.props.datosUsuario.dataUsuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario && this.props.datosUsuario.dataUsuario.usu_tipo_usuario === 'cliente' && "Ver Compras"}
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col lg={12} md={12} sm={12} xs={12}>
              <Card className={"cr-widget bg-light card background-white"} >
                <Row style={{ width: "50%", textAlign: "center" }}>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <div style={{ textAlign: "center" }}><i className="fa fa-file-text-o fa-3x" aria-hidden="true" style={{ color: "#001871" }}></i></div>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <span className="mr-1 badge badge-info badge-pill" style={{ fontSize: "1.5em", background: "#001871", marginTop: "0.3em" }}>
                      {this.props.datosDashboard.datosDashboard.contadorCotizaciones && this.props.datosDashboard.datosDashboard.contadorCotizaciones !== undefined ? this.props.datosDashboard.datosDashboard.contadorCotizaciones : 0}
                    </span>
                  </Col>
                </Row>
                <Row style={{ width: "50%", textAlign: "center" }}>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <CardTitle>CONSULTA</CardTitle>
                    <CardTitle>TUS COTIZACIONES</CardTitle>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                    <Button className={"btn btn-primary"} onClick={this.props.datosUsuario.dataUsuario.usu_tipo_usuario !== 'aglutinador-user' ? this.onCotizaciones : undefined} style={{ display: "block", margin: "auto" }} >
                      <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                      {"Ver Cotizaciones"}
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>

            {
              (this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "broker-user" || this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "asesor-user" || this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "canal-user") &&
              <Col lg={12} md={12} sm={12} xs={12}>
                <Card className={"cr-widget bg-light card background-white"} >
                  <Row style={{ width: "50%", textAlign: "center" }}>
                    <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                      <div style={{ textAlign: "center" }}><i className="fa fa-file-archive-o fa-3x" aria-hidden="true" style={{ color: "#001871" }}></i></div>
                    </Col>
                    <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                      <span className="mr-1 badge badge-info badge-pill" style={{ fontSize: "1.5em", background: "#001871", marginTop: "0.3em" }}>
                        {this.state.numeroRenovaciones}
                      </span>
                    </Col>
                  </Row>
                  <Row style={{ width: "50%", textAlign: "center" }}>
                    <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                      <CardTitle>CONSULTA</CardTitle>
                      <CardTitle>TUS RENOVACIONES</CardTitle>
                    </Col>
                    <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0.5em" }}>
                      <Button className={"btn btn-primary"} onClick={this.onRenovaciones} style={{ display: "block", margin: "auto" }} >
                        <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                        {"Ver Renovaciones"}
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </Col>
            }

          </Col>

          <Col lg={6} md={12} sm={12} xs={12}>
            <Card>
              <CardHeader>Menú de Servicios</CardHeader>
              <CardBody>
                <CardGroup>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Link to={bloquearOpciones ? null : `/lista-cotizadores`}>
                      <div className={bloquearOpciones ? "cr-widget card background-cards-servicios-disabled" : "cr-widget card background-cards-servicios"}>
                        <div className="card-body">

                          <h5 className="card-title" style={{ color: "white" }}>Cotizadores</h5>
                        </div>
                        <div className="cr-widget__icon card-body">
                          <i className="fa fa-globe fa-2x background-cards-iconos" aria-hidden="true"></i>
                        </div>
                      </div>
                    </Link>
                  </Col>


                  {/*     {bloquearRenovaciones && (
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <div className="cr-widget card background-cards-servicios-disabled">
                        <div className="card-body">
                          <h5 className="card-title" style={{ color: "white" }}>Renovaciones</h5>
                        </div>
                        <div className="cr-widget__icon card-body">
                          <i className="fa fa-refresh fa-2x background-cards-iconos" aria-hidden="true"></i>
                        </div>
                      </div>
                    </Col>
                  )}
                  {!bloquearRenovaciones && (
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <Link to={`/renovaciones`}>
                        <div className="cr-widget card background-cards-servicios">
                          <div className="card-body">
                            <h5 className="card-title" style={{ color: "white" }}>Renovaciones</h5>
                          </div>
                          <div className="cr-widget__icon card-body">
                            <i className="fa fa-refresh fa-2x background-cards-iconos" aria-hidden="true"></i>
                          </div>
                        </div>
                      </Link>
                    </Col>
                  )} */}


                  {this.props.serviciosMenu.dataServicios.map(({ parCodigo, Nombre, Icon }) => {
                    console.log("parCodigo", `/pantalla-iframe/${parCodigo}`)
                    return <Col lg={6} md={6} sm={12} xs={12}>
                      <Link to={bloquearOpciones ? null : `/pantalla-iframe/${parCodigo}`} cursor='pointer'>
                        <div className={bloquearOpciones ? "cr-widget card background-cards-servicios-disabled" : "cr-widget card background-cards-servicios"}>
                          <div className="card-body">
                            <h5 className="card-title" style={{ color: "white" }}>{Nombre}</h5>
                          </div>
                          <div className="cr-widget__icon card-body">
                            <i className={`fa ${Icon} fa-2x background-cards-iconos`} aria-hidden="true"></i>
                          </div>
                        </div>
                      </Link>
                    </Col>
                  }
                  )
                  }
                  {/* <Col lg={6} md={6} sm={12} xs={12}>
                      <Link to={`/indemnizaciones`}>
                          <div className="cr-widget card background-cards-servicios">
                            <div className="card-body">
                              <h5 className="card-title" style={{ color: "white" }}>Indemnizaciones</h5>
                            </div>
                            <div className="cr-widget__icon card-body">
                              <i className="fa fa-balance-scale fa-2x background-cards-iconos" aria-hidden="true"></i>
                            </div>
                          </div>
                        </Link>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                      <Link to={`/indemnizaciones`}>
                          <div className="cr-widget card background-cards-servicios">
                            <div className="card-body">
                              <h5 className="card-title" style={{ color: "white" }}>Indemnizaciones</h5>
                            </div>
                            <div className="cr-widget__icon card-body">
                              <i className="fa fa-handshake-o fa-2x background-cards-iconos" aria-hidden="true"></i>
                            </div>
                          </div>
                        </Link>
                  </Col> */}
                  {/* <Col lg={6} md={6} sm={12} xs={12}>
                    <div className="cr-widget card background-cards-servicios-disabled">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: "white" }}>Cartera-Cobranzas</h5>
                      </div>
                      <div className="cr-widget__icon card-body">
                        <i className="fa fa-money fa-2x background-cards-iconos" aria-hidden="true"></i>
                      </div>
                    </div>
                  </Col> */}
                  {/* <Col lg={6} md={6} sm={12} xs={12}>
                    <div className="cr-widget card background-cards-servicios-disabled">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: "white" }}>Tracking de Siniestros</h5>
                      </div>
                      <div className="cr-widget__icon card-body">
                        <i className="fa fa-exclamation-triangle fa-2x background-cards-iconos" aria-hidden="true"></i>
                      </div>
                    </div>
                  </Col> */}
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <div className="cr-widget card background-cards-servicios-disabled">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: "white" }}>Materiales</h5>
                      </div>
                      <div className="cr-widget__icon card-body">
                        <i className="fa fa-download fa-2x background-cards-iconos" aria-hidden="true"></i>
                      </div>
                    </div>
                  </Col>
                  {
                    (this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "broker-user" || this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "asesor-user" || this.props.datosUsuario.dataUsuario.usu_tipo_usuario === "canal-user") && (
                      <>
                        <Col lg={6} md={6} sm={12} xs={12}>
                          <Link to={bloquearOpciones ? null : `/polizas-emitidas-vigentes`}>
                            <div className={bloquearOpciones ? "cr-widget card background-cards-servicios-disabled" : "cr-widget card background-cards-servicios"}>
                              <div className="card-body">

                                <h5 className="card-title" style={{ color: "white" }}>Pólizas Emitidas Vigentes</h5>
                              </div>
                              <div className="cr-widget__icon card-body">
                                <i className="fa fa-globe fa-2x background-cards-iconos" aria-hidden="true"></i>
                              </div>
                            </div>
                          </Link>
                        </Col>
                      </>
                    )
                  }

                   {
                    verCompromisos && (
                      
                      <>
                        <Col lg={6} md={6} sm={12} xs={12}>
                          <Link to={`/compromisos/listado`}>
                            <div className={"cr-widget card background-cards-servicios"}>
                              <div className="card-body">

                                <h5 className="card-title" style={{ color: "white" }}>Registro compromiso cuenta</h5>
                              </div>
                              <div className="cr-widget__icon card-body">
                                <i className="fa fa-list-alt fa-2x background-cards-iconos" aria-hidden="true"></i>
                              </div>
                            </div>
                          </Link>
                        </Col>
                      </>
                    )
                  }
                </CardGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>

    );
  }
}

const mapStateToProps = state => ({
  datosDashboard: state.datosDashboard,
  datosUsuario: state.datosUsuarios,
  serviciosMenu: state.rServicios
});
const mapDispatchToProps = dispatch => {
  return {
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Principal)
);
